import { Helper } from '../Helper';
export class RawEnumeratorEveryHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, options) {
        sb.emitHelper(node, options, sb.helpers.rawIteratorEveryBase({
            each: (innerOptions) => {
                sb.emitSysCall(node, 'Neo.Enumerator.Value');
                this.each(innerOptions);
            },
        }));
    }
}

//# sourceMappingURL=RawEnumeratorEveryHelper.js.map
